import { render, staticRenderFns } from "./simpleAutoresponder.vue?vue&type=template&id=4fb9efab&scoped=true&"
import script from "./simpleAutoresponder.vue?vue&type=script&lang=js&"
export * from "./simpleAutoresponder.vue?vue&type=script&lang=js&"
import style0 from "./simpleAutoresponder.vue?vue&type=style&index=0&id=4fb9efab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9efab",
  null
  
)

export default component.exports